module.exports = __webpack_public_path__ + "static/img/logo.3330a941.png";